module.exports = __webpack_public_path__ + "images/mailicon.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mailicon.png
// module id = 4bQz
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13